{
    "AppBar.home": "FR: Home",
    "AppBar.policies": "FR: Policies",
    "AppBar.claims": "FR: Claims",
    "AppBar.account": "FR: My Account",
    "AppBar.logout": "FR: Log Out"
}
